const NAV_TABS_DATA = [
  {
    id: 1,
    title: "Overview",
    href: "/service",
  },
  {
    id: 2,
    title: "Shared Space",
    href: "/shared-space",
  },
  {
    id: 3,
    title: "Team Office",
    href: "/team-office",
  },
  {
    id: 4,
    title: "Executive Office",
    href: "/executive-office",
  },
  {
    id: 5,
    title: "Meeting Hall",
    href: "/meeting-hall",
  },
];

export default NAV_TABS_DATA;
